<svelte:options accessors/>
<script lang="ts">
    import NauiSlideOver from "../../naui/layout/NauiSlideOver.svelte";
    import {getFormatter, httpRequest} from "../../utils";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher, onMount} from "svelte";

    const formatter = getFormatter();
    const dispatch = createEventDispatcher();

    export let data = [];
    export let total = 0;
    export let open = false;

    export let link = '';

    $: disabled = total <= 0;

    export let resumen;

    function removePayment(slug) {
        dispatch('remove', slug)
    }

</script>
<NauiSlideOver bind:open={open} title="Resumen pagos a realizar" maxWidth="350px">
    {#each data as payment (payment.slug)}
        <div class="p-1 radius shadow mb-1 grid-1-auto">
            <table class="simple-table">
                {#each resumen as r (r.atributo)}
                    <tr>
                        <td>{r.titulo}</td>
                        <td>{payment[r.atributo]}</td>
                    </tr>
                {/each}

                <tr>
                    <td>Valor</td>
                    <td><strong>{formatter(payment.valor)}</strong></td>
                </tr>
            </table>
            <NauiButton icon="delete_outline" color="accent" iconStyle="outlined"
                        on:click={removePayment.bind(this, payment.slug)}/>
        </div>
    {/each}
    <div slot="actions">
        <div class="box-r sx-1">
            <strong>Total a pagar {formatter(total)}</strong>
            {#if link || disabled}
                <NauiButton {disabled} caption="Continuar a pago" color="accent" mode="solid" href={link}
                            target="_blank"/>
            {:else}
                <NauiButton caption="Cargando enlace..." color="secondary" mode="outline"/>
            {/if}
        </div>
    </div>
</NauiSlideOver>